import CN from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../../components/Button";
import ImageUpload, { Image } from "./plugins/ImageUpload";
import { useSelector } from "react-redux";
import store from "../../store/store";
import { Oval } from "react-loader-spinner";
import { addCategory } from "../Categories/reducer/categorySlice";

interface FormValues {
  category: string;
  description: string;
  file?: File[] | string;
  isPopular: boolean;
}

export const AddCategory: React.FC<any> = () => {
  const { isLoading } = useSelector(
    (state: any) => state.rootReducer?.category
  );
  const navigate = useNavigate();

  // Validation schema
  const validationSchema = Yup.object({
    category: Yup.string()
      .required("Category Name is required")
      .max(50, "Category Name must be 50 characters or less"),
    description: Yup.string()
      .required("Description is required")
      .max(30, "Description must be 30 characters or less")
      .min(10, "Description must be at least 10 characters long"),
    // images: Yup.array().min(1, "At least one image is required"),
    // logo: Yup.array(),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik<FormValues>({
    initialValues: {
      category: "",
      description: "",
      file: [],
      isPopular: false,
    },
    validationSchema,
    onSubmit: (values: FormValues) => {
      const formData = new FormData();
      console.log('values', values)

      Object.entries(values).forEach(([key, value]) => {
        if (key === "file") {
          if (value) {
            formData.append("file", value as File);
          }
        } else if (Array.isArray(value)) {
          value.forEach((val) => formData.append(`${key}[]`, val));
        } else {
          formData.append(key, value as string);
        }
      });

      console.log('formData', formData)

      // addProductContext?.addNewProduct(formData);
      store.dispatch(addCategory(formData));
    },
  });

  const handleImageUpload = (image: File | Image | null) => {
    console.log('image', image)
    setFieldValue("file", image);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <form
        onSubmit={handleSubmit}
       
      >

        <div  className="lg:grid grid-cols-2 flex flex-col gap-6 my-4 py-8 lg:mx-8 mx-4">

        {/* Category Logo */}
        <div className="col-span-2">
          <label className="block text-base font-semibold mb-2">
            Category Logo <span className="text-red-500">*</span>
          </label>

          <ImageUpload onUpload={handleImageUpload} />

          {errors.file && touched.file && (
            <p className="text-red-500 text-sm my-2">{errors.file}</p>
          )}
        </div>

        {/* Product Name */}
        <div className="col-span-1">
          <label className="block text-base font-semibold mb-2">
            Category Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="category"
            value={values.category}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Untitled category"
            className={CN(
              "block w-full p-3 border rounded-md",
              errors.category && touched.category ? "border-red-500" : "border-primary1"
            )}
          />
          {errors.category && touched.category && (
            <p className="text-red-500 text-sm my-2">{errors.category}</p>
          )}
        </div>

    

        {/* Description */}
        <div className="col-span-1">
          <div className="flex flex-col gap-1 mb-2">
            <label className="block text-base font-semibold">
              Description
              <span className="text-red-500">*</span>
            </label>
          </div>
          <textarea
            name="description"
            value={values.description}
            onChange={handleChange}
            onBlur={handleBlur}
            className={CN(
              "block w-full p-3 border rounded-md",
              errors.description && touched.description
                ? "border-red-500"
                : "border-primary1"
            )}
          />
          {errors.description && touched.description && (
            <p className="text-red-500 text-sm my-2">{errors.description}</p>
          )}
        </div>

             {/* Popular Product */}
             <div className="col-span-2 flex items-start">
          <input
            type="checkbox"
            name="isPopular"
            className="accent-primary1 w-[18px] h-[18px] mr-3 my-1 cursor-pointer rounded border border-primary1"
            onChange={(e) => setFieldValue("isPopular", e.target.checked)}
            checked={values.isPopular}
          />
          <div className="flex flex-col gap-1 mb-2">
            <label className="block text-base font-semibold">
              Popular Category
            </label>
            <span className="font-normal text-sm">
              Mark this category as popular
            </span>
          </div>
        </div>
        </div>


        {/* Buttons */}
        <div className={`flex justify-end flex-row gap-4 mt-5 py-4 w-full sticky bottom-0 bg-primary2 lg:px-8 px-4`}>

        <div className="col-span-2 flex justify-end gap-5">
          <Button onClick={() => navigate("/categories")} apparence="gray">
            Cancel
          </Button>

          <Button isLoading={isLoading.categoryAdd} view="default" type="submit">
            <div className="flex gap-1">
              {isLoading.categoryAdd && (
                <Oval
                  height={18}
                  width={18}
                  color="#ffff"
                  wrapperStyle={{}}
                  wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="gray-primary"
                  strokeWidth={6}
                  strokeWidthSecondary={6}
                />
              )}
              <div className="font-normal text-base">Save</div>
            </div>
          </Button>
        </div>

        </div>
      </form>
    </motion.div>
  );
};

export default AddCategory;
